export default __webpack_public_path__ + "static/media/ActiveDevice.9c9dd701.svg";